import React, { useEffect } from 'react';
import Individual from './components/Public/Main/Individual'


import './css/leo.css'
import './css/brian.css'
import './css/blake.css'
import '@availity/block-ui/dist/index.css';
import MainInternal from './components/Internal/Main/Main';
import PublicIndividual from './components/Public/Main/Individual';
import Main from './components/Public/Main/Main';
import reducer from './components/Shared/CustomReducer';
import { Provider } from 'react-redux';
import { combineReducers, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import storage from 'redux-persist/lib/storage'
import storageSession from 'redux-persist/lib/storage/session'
import withClearCache from "./ClearCache";
import axios from "axios";

const ClearCacheComponent = withClearCache(MainApp);

// This is because rsuite PickerPopup.tsx doesn't respect the screens bounds
// This started in rsuite 5.2.2 and we've added this for their 5.83.1 version. Hopefully they make a fix for this but it should be a relatively harmless error.
const useHideUnimportantErrors = () => {
    useEffect(() => {
        function hideError(e) {
            if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                );
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                );
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        }

        window.addEventListener('error', hideError)
        return () => {
            window.addEventListener('error', hideError)
        }
    }, [])
}
// localStorage is shared across every same-origin tab, but each tab's in-memory
// React/Redux state (which app shell to render, which account's data is loaded)
// is only computed once on load. Switching/adding/removing an account in one tab
// silently changes localStorage["user"] under every other open tab too, while
// those tabs keep rendering their old shell - yet every subsequent API call from
// them reads the auth token fresh from localStorage, so they start authenticating
// as the new account while still showing the old one. The browser's `storage`
// event fires in every OTHER same-origin tab (never the one that made the
// change), so use it to force a reload and stay consistent.
const useCrossTabAccountSync = () => {
    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === "user" || e.key === null) {
                window.location.reload();
            }
        };
        window.addEventListener('storage', handleStorage);
        return () => {
            window.removeEventListener('storage', handleStorage);
        };
    }, []);
};

function App() {
    useHideUnimportantErrors();
    useCrossTabAccountSync();
    return <ClearCacheComponent />
}

function MainApp(props) {
    axios.interceptors.response.use(function (res) {
        return res;
    },
        (err) => {
            if (err.response?.status == 503 || err.message == "Network Error") {
                //handle error of type
                fetch("/meta.json?ms=" + Date.now())
                    .then((response) => { return response.json(); })
                    .then((meta) => {
                        if (!meta || meta.offline == true)
                        {
                            window.location.href = "https://www.lapels.com/Sched_Maint.html";
                        }
                    });
            }
            return Promise.reject(err);
        });
    const persistConfig = {
        key: 'root',
        storage: storageSession,
        blacklist: ['userInfo']
    }
    const userConfig = {
        key: 'user',
        storage
    }
    const rootReducer = combineReducers({
        userInfo: persistReducer(userConfig, reducer.userInfo),
        currentApplicationId: reducer.currentApplicationId,
        currentApplicationEntityId: reducer.currentApplicationEntityId,
        currentApplicationTypeId: reducer.currentApplicationTypeId,
        currentRoutes: reducer.currentRoutes,
        refreshToken: reducer.refreshToken,
        currentInvoiceId: reducer.currentInvoiceId,
        refreshRecentQueue: reducer.refreshRecentQueue,
        refreshRecentContacts: reducer.refreshRecentContacts,
        currentBoardParentTypeId: reducer.currentBoardParentTypeId,
        currentBoardMemberResponseId: reducer.currentBoardMemberResponseId
    });

    const persistedReducer = persistReducer(persistConfig, rootReducer)
    const store = createStore(persistedReducer);
    const persistor = persistStore(store);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Main />
            </PersistGate>
        </Provider>
    );
}

export default App;
